import React from "react";

import "./UserGuide.css";
import { Helmet } from "react-helmet-async";
function SafeShopping() {

  return (

    <div className="user-guide-page">

      {/* SEO META */}
      <Helmet>
        <title>Safe Shopping | Secure Online Pharmacy Guide</title>
        <meta
          name="description"
          content="Learn how MediCare ensures safe and secure online shopping with encrypted payments, privacy protection, and trusted medicines."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://realgenericshop.com/safe-shopping" />
      </Helmet>

      <div className="user-guide-container">

        <h1 className="user-guide-title">
          Safe and Secure Shopping
        </h1>

        <div className="user-guide-content">

          <p>
            MediCare ensures a safe and secure online shopping
            experience for all customers. We follow strict
            security measures to protect your data and transactions.
          </p>

          <h3>Secure Payments</h3>

          <ul>

            <li>
              All transactions are encrypted using SSL technology
            </li>

            <li>
              Multiple trusted payment options available
            </li>

            <li>
              No sensitive data is stored without protection
            </li>

          </ul>

          <h3>Privacy Protection</h3>

          <ul>

            <li>
              Your personal information is kept confidential
            </li>

            <li>
              We do not share your data with unauthorized parties
            </li>

            <li>
              Secure login and account protection systems
            </li>

          </ul>

          <h3>Trusted Products</h3>

          <ul>

            <li>
              100% genuine and verified medicines
            </li>

            <li>
              Sourced from licensed suppliers
            </li>

            <li>
              Proper packaging and handling
            </li>

          </ul>

          <h3>Tips for Safe Shopping</h3>

          <ul>

            <li>
              Always use strong passwords
            </li>

            <li>
              Do not share OTP or account details
            </li>

            <li>
              Log out from shared devices
            </li>

          </ul>

          <h3>Our Commitment</h3>

          <p>
            We are committed to providing a reliable,
            secure, and hassle-free shopping experience
            every time you visit MediCare.
          </p>

        </div>

      </div>

    </div>

  );

}

export default SafeShopping;